import React, {useState, useEffect} from 'react';
import { Link } from "react-router-dom";

const RecipeList = () => {

    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        const getRecipes = async () => {
            const data = await fetch('https://recipe-app-backend-ionut.herokuapp.com/');
            const response = await data.json();
            setRecipes(response);
        }
        getRecipes();

    },[recipes])

    const renderAllRecipes = () => {
        return recipes.map((item, i) => {
            return (
                <p key={i}>
                    <Link to={`/recipes/${item._id}`}>
                        {item.name}
                    </Link>
                </p>
            );
        });
    }

    return (
        <div className="recipes-list">
            <ul>
                {renderAllRecipes()}
            </ul>
        </div>
    );
}

export default RecipeList;